import { Box, Button, Divider, InputLabel, Stack, Typography } from "@mui/material";
import { EboStoreState } from "context/EboStoreContext";
import { inputTypes, statusOptions } from "data/pimData";
import { converAttrToDatagridCol, datatypes } from "data/globalData";
import moment from "moment";
import { DataGrid, GridFooter, GridFooterContainer } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { GlobalState } from "context/GlobalContext";
import CustomFooter, { addOrEditModelAction, employeeDetailsTableColumns } from "components/EboStoreV4/data";
import { grey } from "@mui/material/colors";
import AddOrEditModal from "./AddOrEditModal/AddOrEditModal";

const EmployeeDetailsTable = ({ employeeDetails, setEmployeeDetails, handleCreateEmployee }) => {
	const [addOrEditModal, setAddOrEditModal] = useState(false);
	const [addOrEditModalType, setAddOrEditModalType] = useState(addOrEditModelAction.CREATE);
	const navigate = useNavigate();

	return (
		<Stack p={1} width="95%" margin="auto" spacing={1}>
			<Box display="flex" justifyContent="flex-end">
				<Button
					size="small"
					disabled={employeeDetails.status === statusOptions.PUBLISHED.key}
					variant="contained"
					onClick={() => setAddOrEditModal(true)}>
					Add
				</Button>
			</Box>
			<Box>
				<DataGrid
					rows={employeeDetails?.eboStoreEmployeeDetails}
					getRowId={(row) => row.id}
					columns={[...employeeDetailsTableColumns?.map((col) => converAttrToDatagridCol(col))]}
					sx={{
						minHeight: 220,
						maxHeight: 300,
						width: "100%",
						border: "none",
						"& .MuiDataGrid-row": {
							// borderBottom: "1px solid lightgray",
							cursor: "pointer",
							border: "none",
						},
						"& .MuiDataGrid-columnHeader": {
							cursor: "pointer",
							background: grey[300],
						},
					}}
					columnHeaderHeight={35}
					rowHeight={40}
					disableAutosize
					// onRowClick={({ row }) => handleModalOpen(addOrEditModelAction.UPDATE, row)}
					disableRowSelectionOnClick
					pageSizeOptions={[5, 10]}
				/>
			</Box>
			{addOrEditModal && (
				<AddOrEditModal
					modal={addOrEditModal}
					setModal={setAddOrEditModal}
					type={addOrEditModalType}
					employeeDetails={employeeDetails}
					setEmployeeDetails={setEmployeeDetails}
					handleCreateEmployee={handleCreateEmployee}
				/>
			)}
		</Stack>
	);
};

export default EmployeeDetailsTable;
